import { trpc } from "@lango/api";
import { useRouter } from "next/router";

export const useBot = (id?: string) => {
  const {
    query: { id: queryID },
  } = useRouter();
  const { data, isLoading, refetch } = trpc.getBot.useQuery({
    id: id || (queryID as string),
  });

  return {
    data,
    isLoading,
    refetch,
  };
};
